
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/typing-practice",
      function () {
        return require("private-next-pages/typing-practice.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/typing-practice"])
      });
    }
  